import { render } from "./GalleriaContent.vue?vue&type=template&id=0fbaa742"
import script from "./GalleriaContent.vue?vue&type=script&lang=js"
export * from "./GalleriaContent.vue?vue&type=script&lang=js"
script.render = render

export default script